import React, { Component } from 'react';
import { Row, Col, Alert, Spin } from 'antd';
import { PdfPreview } from './PdfPreview';
import { AddressAutoComplete } from './AddressAutoComplete';

export class Home extends Component {
  displayName = Home.name;
  constructor() {
    super();
    this.state = {
      error: undefined,
      pdf: undefined,
      loading: false
    };

    this.onSelectAddress = this.onSelectAddress.bind(this);
    this.onError = this.onError.bind(this);
    this.onLoading = this.onLoading.bind(this);
  }

  onSelectAddress(pdf) {
    this.setState({ pdf, error: undefined, loading: false });
  }

  onError(error) {
    this.setState({ error, pdf: undefined, loading: false });
  }

  onLoading() {
    this.setState({ error: undefined, pdf: undefined, loading: true });
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col span={12} offset={6} style={{ marginTop: 10 }}>
            <AddressAutoComplete
              onSelectAddress={this.onSelectAddress}
              onError={this.onError}
              onLoading={this.onLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12} offset={6} style={{ marginTop: 70, display: 'flex', justifyContent: 'center' }}>
            {this.state.error && (
              <Alert message="Ett fel inträffade..." description={this.state.error.error} type="error" showIcon />
            )}
            {this.state.loading && <Spin size="large" />}
            <PdfPreview pdf={this.state.pdf} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js